import Icons from "../../../assets/js/Icons"

export const forMembers = [
  {
    name: "Login",
    path: "/login",
  },
  {
    name: "Register",
    path: "/register",
  },
  {
    path: "/login",
    name: "Member Dashboard",
  },
]
export const forSpecialists = [
  {
    name: "Login",
    path: "/login",
  },
  {
    name: "Register",
    path: "/specialist-registration",
  },
  {
    path: "/login",
    name: "Appointment Requests",
  },
  {
    path: "/login",
    name: "Specialist Dashboard",
  },
]

export const quickLinks = [
  {
    name: "Home",
    path: "/home",
  },
  {
    name: "Services",
    path: "/services",
  },
  {
    name: "Find specialist",
    path: "/find-specialist",
  },
  {
    name: "Pricing",
    path: "/pricing",
  },
  {
    name: "Blogs",
    path: "/blogs",
  },
]

export const support = [
  {
    name: "Help Center",
    path: "/help-center",
  },
  {
    path: "/faqs",
    name: <>FAQ's</>,
  },
]

export const legal = [
  {
    name: "Term of service",
    path: "/terms-and-conditions",
  },
  {
    name: "Privacy policy",
    path: "/privacy-policy",
  },
  {
    name: "Cookie policy",
    path: "/cookie-policy",
  },
  {
    name: "Refund policy",
    path: "/refund-policy",
  },
]

export const socialMediaLinks = [
  {
    icon: <Icons.Facebook />,
    path: "https://www.addtoany.com/add_to/facebook?linkurl=https%3A%2F%2Ftest.innerpal.com%2F&linkname=Emotional%20Wellness%20%7C%20Platonic%20Relationship%20%7C%20Loving%20Kindness%20Meditation%20%E2%80%93%20InnerPal&linknote=",
  },
  {
    icon: <Icons.TwitterX />,
    path: "https://www.addtoany.com/add_to/twitter?linkurl=https%3A%2F%2Ftest.innerpal.com%2F&linkname=Emotional%20Wellness%20%7C%20Platonic%20Relationship%20%7C%20Loving%20Kindness%20Meditation%20%E2%80%93%20InnerPal&linknote=",
  },
  {
    icon: <Icons.LinkedIn />,
    path: "https://www.addtoany.com/add_to/linkedin?linkurl=https%3A%2F%2Ftest.innerpal.com%2F&linkname=Emotional%20Wellness%20%7C%20Platonic%20Relationship%20%7C%20Loving%20Kindness%20Meditation%20%E2%80%93%20InnerPal&linknote=",
  },
]